import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BasicModal from '../../../../../common/src/components/BasicModal';
import LargeButton from '../../../../../common/src/components/LargeButton';

interface Props {
  showModal: boolean;
  onClose?: () => void;
}

const EmptyCardModalMobile: React.FC<React.PropsWithChildren<Props>> = ({
  showModal,
  onClose = () => null,
}) => {
  const { t } = useTranslation();
  return (
    <BasicModal showModal={showModal} onClose={onClose}>
      <Container>
        <Title>{t('You have not selected any offers yet')}</Title>
        <Text>
          {t(
            'Please select at least one offer before trying to view your selected offers',
          )}
        </Text>
        <StyledLargeButton onClick={onClose}>{t('Close')}</StyledLargeButton>
      </Container>
    </BasicModal>
  );
};

const StyledLargeButton = styled(LargeButton)`
  display: block;
  margin-left: auto;
  padding: 0 3.2rem;
  min-width: unset;
`;

const Container = styled.div`
  padding: 2.4rem;
`;

const Title = styled.h3`
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 125%;
  margin-bottom: 1.6rem;
`;
const Text = styled.p`
  font-size: 1.6rem;
  line-height: 120%;
  color: ${({ theme }) => theme.labels.guaranteeText};
  margin-bottom: 2.4rem;
`;

export default EmptyCardModalMobile;
